import { useQuery } from "@tanstack/react-query";
import { isAxiosError } from "axios";
import { api } from "../../../singleton/axios";
import { HouseLatest } from "./useHouseLatest";

interface HouseTradesByNameResponse {
  data: HouseLatest[];
  member: string;
  count: number;
}

interface UseHouseTradesByNameParams {
  name: string;
  enabled?: boolean;
}

export const useHouseTradesByName = ({
  name,
  enabled = true,
}: UseHouseTradesByNameParams) => {
  return useQuery({
    queryKey: ["house-trades-by-name", name],
    queryFn: async (): Promise<HouseTradesByNameResponse> => {
      const response = await api.get("/house-trades-by-name", {
        params: { name },
      });
      return response.data;
    },
    enabled: enabled && !!name && name.trim().length > 0,
    staleTime: 10 * 60 * 1000, // 10 minutes - fresher data for better UX
    refetchOnWindowFocus: false,
    retry: (failureCount, error) => {
      if (isAxiosError(error) && error.response?.status === 404) return false;
      return failureCount < 2;
    },
  });
};

export type { HouseTradesByNameResponse };
